import React from 'react';
import { Box, Text } from '@chakra-ui/react';

type Props = {
  /** Appropriate phone number for the location of the page */
  phoneNumber: string;
};

/** Shows a call to action on a page with a phone number to help encourage people to call and ask questions */
export const PhoneDetails = ({ phoneNumber }: Props): JSX.Element => (
  <Box flex="0 0 100%" mt={[0, '-150px']} mb={[4, 16]} p={[5, 0, 0]}>
    <Box
      textAlign="center"
      p={[5]}
      mt={[0, 6]}
      mx="auto"
      maxWidth="700px"
      bg="white"
      border="darkgrey"
      sx={{
        borderColor: '#027fb040',
        borderWidth: 'default',
        borderStyle: 'solid',
        borderRadius: '20px',
        fontWeight: 'bold',
      }}
    >
      <Text>Have questions? Give us a call and we'll walk you through it.</Text>
      <Text>
        <a
          href={`
        tel:${phoneNumber}
      `}
        >
          {phoneNumber}
        </a>
      </Text>
    </Box>
  </Box>
);
